<script>
    import axios from 'axios'
    import AppMixin from './../../../mixins/AppMixin'
    import {nextTick} from "vue";
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import TemplatesLabelCounts from "../../../templates/LabelCounts.vue";
    import Textarea from "primevue/textarea";
    import Checkbox from "primevue/checkbox";
    import InputNumber from "primevue/inputnumber";
    import RadioButton from "primevue/radiobutton";
    import Divider from "primevue/divider";
    export default {
        mixins: [AppMixin],
        data() {
            return {
                loading: false,
                list: null,
                error: null,
                model: {}

            }
        },
        props: ["name", "reportRid", "type", "target", "config"],
        methods: {
            save(){
                let self = this;
                if(this.getData.length === 0){
                    this.error = this.$t('lang.group_report.dom_length_1_err');
                    return false;
                }

                if(!this.model.keysFromOrganic && !this.model.keysFromContext){
                    this.error = this.$t('lang.group_report.keys_type_err');
                    return false;
                }

                self.loading = true;

                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                    data: {
                        domains: self.getData,
                        config: self.model,
                    }
                })
                    .then(function (response) {

                        self.loading = false;
                        window.location.reload();

                    })
                    .catch(function (error) {
                        self.loading = false;
                        self.error = error.response.data.message;
                    });


            },
            onClose() {
                this.list = null;
                this.config.ids = null;
                this.error = null
            },
            onOpen() {
                let self = this;
                nextTick(() => {
                    self.$refs["modalInput"].$el.focus()
                });

                if (this.config.ids && this.config.ids.length > 0) {
                    this.list = this.config.ids.join("\n");
                }

                if (this.target === "all") {
                    this.model = {
                        keysFromOrganic: true,
                        keysFromOrganicOr: false,
                        keysFromContext: true,
                        keysFromContextOr: false,
                    };

                } else {
                    this.model = {
                        keysFromOrganic: this.target === "organic",
                        keysFromOrganicOr: false,
                        keysFromContext: this.target === "context",
                        keysFromContextOr: false,
                    };

                }

            }
        },
        computed: {
            getApiUrl(){
                return this.$config.API_URL + '/report/group/' + this.type + '/domain/' + this.reportRid;
            },
            getData(){
                if(this.list){
                    return this.list.replace(/\r\n/g,"\n").split("\n").filter(item => {return item != ""});
                }
                return [];
            },
            btnModalLabel(){
                return this.type === 'import' ? this.$t('lang.main.btn.add') : this.$t('lang.main.btn.delete');
            },
            filterLabel(){
                return this.type === 'import' ? this.$t('lang.group_report.add_keys_run') : this.$t('lang.group_report.delete_keys_run');
            },
            count(){
                return this.getData.length;
            },
            resultOrganicStr(){
                let result = [], interResult = [];

                let config = {
                    [this.$t('lang.main.f_pos_label')]: [
                        {condition: '>=', field: 'organicPosFrom'}, {condition: '<=', field: 'organicPosTo'},
                    ],
                    [this.$t('lang.main.f_ws_label')]: [
                        {condition: '>=', field: 'organicWsFrom'}, {condition: '<=', field: 'organicWsTo'},
                    ]
                };

                if(this.isYandex){
                    config[this.$t('lang.main.f_wsk_label')] = [
                        {condition: '>=', field: 'organicWskFrom'}, {condition: '<=', field: 'organicWskTo'},
                    ];
                }

                for (let prop in config) {
                    config[prop].forEach((c) => {
                        if(this.model.hasOwnProperty(c.field) && this.model[c.field] !== ""){
                            interResult.push(prop + " " + c.condition + " " + this.model[c.field]);
                        }
                    });

                    if(interResult.length > 0){
                        result.push("(" + interResult.join(" " + this.$t('lang.main.filter.and') + " ") + ")");
                        interResult = [];
                    }

                }


                if(result.length === 0){
                    return null;
                }

                return "(" + result.join(this.model.keysFromOrganicOr ? (" " + this.$t('lang.main.filter.or') + " ") : (" " + this.$t('lang.main.filter.and') + " ")) + ")"
            },
            resultContextStr(){
                let result = [], interResult = [];

                let config = {
                    [this.$t('lang.main.f_ws_label')]: [
                        {condition: '>=', field: 'contextWsFrom'}, {condition: '<=', field: 'contextWsTo'},
                    ]
                };

                if(this.isYandex){
                    config[this.$t('lang.main.f_wsk_label')] = [
                        {condition: '>=', field: 'contextWskFrom'}, {condition: '<=', field: 'contextWskFrom'}
                    ];
                }


                for (let prop in config) {
                    config[prop].forEach((c) => {
                        if(this.model.hasOwnProperty(c.field) && this.model[c.field] !== ""){
                            interResult.push(prop + " " + c.condition + " " + this.model[c.field]);
                        }
                    });

                    if(interResult.length > 0){
                        result.push("(" + interResult.join(" " + this.$t('lang.main.filter.and') + " ") + ")");
                        interResult = [];
                    }

                }


                if(result.length === 0){
                    return null;
                }

                return "(" + result.join(this.model.keysFromContextOr ? (" " + this.$t('lang.main.filter.or') + " ") : (" " + this.$t('lang.main.filter.and') + " ")) + ")"
            }
        },
        components: {
            TemplatesLabelCounts,
            AdaptersDialog,
            Textarea,
            Checkbox,
            InputNumber,
            RadioButton,
            Divider,
        },
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="name"
        :callback-on-show="onOpen"
        :callback-on-hide="onClose"
        :header="$t('lang.group_report.domain_list')"
        :loading="loading"
        :error-message="error"
        :callback-agree="save"
        :button-agree-label="btnModalLabel"
    >
        <template #content>
            <div class="field">
                <TemplatesLabelCounts :text="$t('lang.group_report.domain_list_rules')" />
                <Textarea v-model="list" rows="6" ref="modalInput" />
            </div>
            <p>{{ $t('lang.main.f_rules') }}</p>
            <div class="field-checkbox">
                <Checkbox v-model="model.keysFromOrganic" inputId="fromOrganic" binary />
                <label for="fromOrganic">{{ $t('lang.main.f_keys_organic') }}</label>
            </div>
            <template v-if="model.keysFromOrganic">
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="organicPosFrom">{{$t('lang.main.f_pos_label')}} {{$t('lang.main.f_from')}}</label>
                            <InputNumber v-model.number="model.organicPosFrom" inputId="organicPosFrom" :min="1" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="organicPosTo">{{$t('lang.main.f_pos_label')}} {{$t('lang.main.f_to')}}</label>
                            <InputNumber v-model.number="model.organicPosTo" inputId="organicPosTo" :max="50" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="organicWsFrom">
                                {{this.isGoogleGny ? $t('lang.main.f_frequency_label') : $t('lang.main.f_ws_label')}} {{$t('lang.main.f_from')}}
                            </label>
                            <InputNumber v-model.number="model.organicWsFrom" inputId="organicWsFrom" :min="0" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="organicWsTo">
                                {{this.isGoogleGny ? $t('lang.main.f_frequency_label') : $t('lang.main.f_ws_label')}} {{$t('lang.main.f_to')}}
                            </label>
                            <InputNumber v-model.number="model.organicWsTo" inputId="organicWsTo" />
                        </div>
                    </div>
                    <template v-if="isYandex">
                        <div class="col-12 md:col-6">
                            <div class="field mb-0">
                                <label for="organicWskFrom">{{$t('lang.main.f_wsk_label')}} {{$t('lang.main.f_from')}}</label>
                                <InputNumber v-model.number="model.organicWskFrom" inputId="organicWskFrom" :min="0" />
                            </div>
                        </div>
                        <div class="col-12 md:col-6">
                            <div class="field mb-0">
                                <label for="organicWskTo">{{$t('lang.main.f_wsk_label')}} {{$t('lang.main.f_from')}}</label>
                                <InputNumber v-model.number="model.organicWskTo" inputId="organicWskTo" />
                            </div>
                        </div>
                    </template>
                </div>
                <div class="mb-4"></div>
                <div class="grid">
                    <div class="col">
                        <div class="field">
                            <label>{{filterLabel}}</label>
                            <div class="formgroup-inline">
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.keysFromOrganicOr" :value="false" inputId="keysFromOrganicAnd" />
                                    <label for="keysFromOrganicAnd">{{ $t('lang.main.f_rule_and') }}</label>
                                </div>
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.keysFromOrganicOr" :value="true" inputId="keysFromOrganicOr" />
                                    <label for="keysFromOrganicOr">{{ $t('lang.main.f_rule_or') }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-if="resultOrganicStr">
                    <div class="grid">
                        <div class="col">
                            <code>{{ resultOrganicStr }}</code>
                        </div>
                    </div>
                </template>
                <Divider />
            </template>

            <div class="field-checkbox">
                <Checkbox v-model="model.keysFromContext" inputId="fromContext" binary />
                <label for="fromContext">{{ $t('lang.main.f_keys_context') }}</label>
            </div>
            <template v-if="model.keysFromContext">
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="contextWsFrom">
                                {{this.isGoogleGny ? $t('lang.main.f_frequency_label') : $t('lang.main.f_ws_label')}} {{$t('lang.main.f_from')}}
                            </label>
                            <InputNumber v-model.number="model.contextWsFrom" inputId="contextWsFrom" :min="0" />
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <div class="field mb-0">
                            <label for="contextWsTo">
                                {{this.isGoogleGny ? $t('lang.main.f_frequency_label') : $t('lang.main.f_ws_label')}} {{$t('lang.main.f_to')}}
                            </label>
                            <InputNumber v-model.number="model.contextWsTo" inputId="contextWsTo" />
                        </div>
                    </div>
                    <template v-if="isYandex">
                        <div class="col-12 md:col-6">
                            <div class="field mb-0">
                                <label for="contextWskFrom">{{$t('lang.main.f_wsk_label')}} {{$t('lang.main.f_from')}}</label>
                                <InputNumber v-model.number="model.contextWskFrom" inputId="contextWskFrom" :min="0" />
                            </div>
                        </div>
                        <div class="col-12 md:col-6">
                            <div class="field">
                                <label for="contextWskTo">{{$t('lang.main.f_wsk_label')}} {{$t('lang.main.f_from')}}</label>
                                <InputNumber v-model.number="model.contextWskTo" inputId="contextWskTo" />
                            </div>
                        </div>
                    </template>
                </div>
                <div class="grid">
                    <div class="col">
                        <div class="field">
                            <label>{{filterLabel}}</label>
                            <div class="formgroup-inline">
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.keysFromContextOr" :value="false" inputId="keysFromContextAnd" />
                                    <label for="keysFromContextAnd">{{ $t('lang.main.f_rule_and') }}</label>
                                </div>
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.keysFromContextOr" :value="true" inputId="keysFromContextOr" />
                                    <label for="keysFromContextOr">{{ $t('lang.main.f_rule_or') }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-if="resultContextStr">
                    <div class="grid">
                        <div class="col">
                            <code>{{ resultContextStr }}</code>
                        </div>
                    </div>
                </template>
            </template>
        </template>
    </AdaptersDialog>
</template>
